import { workflowTaskType } from '@/lib/constants/workflowEmailStatuses'

export default {
  methods: {
    isAutomatedTask (task) {
      return task.taskTypeId === workflowTaskType.AutomatedDocument || task.taskTypeId === workflowTaskType.AutomatedEmail
    },
    isAutomatedDocumentTask (task) {
      return task.taskTypeId === workflowTaskType.AutomatedDocument
    },
    isAutomatedEmailTask (task) {
      return task.taskTypeId === workflowTaskType.AutomatedEmail
    }
  }
}
